import type {User} from '@perfectpost/perfect-post-common';
import {useQueryClient} from '@tanstack/react-query';
import {useCallback} from 'react';

import {meQueryOptions} from './queries/useMeQuery';

/**
 * Lit le profil de façon impérative, en dehors du rendu.
 *
 * Utile aux quelques endroits qui ont besoin de la valeur pour DÉCIDER (ici :
 * rediriger ou non vers la connexion LinkedIn), pas pour l'afficher. Les thunks
 * rendaient ça naturel (`await dispatch(getMe()).unwrap()`) ; côté React Query
 * c'est `ensureQueryData`, qui sert le cache s'il est frais et déclenche la
 * requête sinon.
 */
export function useFetchMe() {
  const queryClient = useQueryClient();

  return useCallback(async (): Promise<User | undefined> => {
    const data = await queryClient.ensureQueryData(meQueryOptions());
    return data.me;
  }, [queryClient]);
}
